import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

const BADMINTON_PLAYER_MISCONDUCT_ROWS = [
  {
    card: 'Yellow Card',
    ruling: 'Warning',
    detail:
      'The umpire gives this for misconduct, such as shouting, arguing with officials, or intentional delays. It serves as a formal caution to stop the behavior without losing a point.',
  },
  {
    card: 'Red Card',
    ruling: 'Fault',
    detail:
      'A red card is issued for misconduct after a yellow card has already been given, or for a more serious first-time offence. This card awards one point to the opponent.',
  },
  {
    card: 'Multiple Cards',
    ruling: 'Escalation',
    detail:
      'If a player continues to misbehave after a red card, they can receive another red card, which gives another point to the opponent, or a black card.',
  },
  {
    card: 'Black Card',
    ruling: 'Disqualification',
    detail:
      'Given by the umpire, following a ruling by the referee, for severe or persistent misconduct. The player is immediately disqualified from the match.',
  },
] as const;

export function BadmintonPlayerMisconductTable() {
  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Player misconduct guidance for badminton match behavior and card escalation.
      </Typography>
      <TableContainer sx={{ border: '1px solid #cde7e3', borderRadius: 1, bgcolor: '#fff' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: '#f0fbf9' }}>
              <TableCell sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>Card</TableCell>
              <TableCell sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>Meaning</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Misconduct Rule</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {BADMINTON_PLAYER_MISCONDUCT_ROWS.map((row) => (
              <TableRow key={row.card}>
                <TableCell sx={{ fontWeight: 700 }}>{row.card}</TableCell>
                <TableCell>{row.ruling}</TableCell>
                <TableCell>{row.detail}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
